export const PUBLIC_IMG_URL = "https://storage.googleapis.com/vaaputtajat"